import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

const MAP_IMG =
  "https://images.pexels.com/photos/41949/earth-earth-at-night-night-lights-41949.jpeg?auto=compress&cs=tinysrgb&w=1600";

const W = 1000;
const H = 500;
const project = (lat, lng) => ({ x: ((lng + 180) / 360) * W, y: ((90 - lat) / 180) * H });

const SEV = { medium: "#39d0ff", high: "#b026ff", critical: "#ff2d6f" };

// Map of possible data leaks tied to the user's email exposure.
export const LeakMap = ({ leaks = [], home }) => {
  const points = leaks.map((l) => ({ ...l, ...project(l.lat, l.lng) }));
  const hp = home ? project(home.lat, home.lng) : null;

  return (
    <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-[#03050d]" data-testid="leak-map">
      <div className="relative" style={{ aspectRatio: "2 / 1" }}>
        <img src={MAP_IMG} alt="Mapa de filtraciones" className="absolute inset-0 h-full w-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-[#03050d]/40" />
        <svg viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none" className="absolute inset-0 h-full w-full">
          {hp && points.map((p, i) => {
            const path = `M ${hp.x} ${hp.y} Q ${(hp.x + p.x) / 2} ${(hp.y + p.y) / 2 - 60} ${p.x} ${p.y}`;
            const c = SEV[p.severity] || "#39d0ff";
            return (
              <path key={`a${p.id}`} d={path} fill="none" stroke={c} strokeWidth="1" opacity="0.35"
                style={{ strokeDasharray: 4, filter: `drop-shadow(0 0 2px ${c})` }} />
            );
          })}
          {points.map((p, i) => {
            const c = SEV[p.severity] || "#39d0ff";
            return (
              <g key={p.id}>
                <circle cx={p.x} cy={p.y} r="4" fill={c} style={{ filter: `drop-shadow(0 0 6px ${c})` }}>
                  <animate attributeName="r" values="3;9;3" dur="2.4s" begin={`${i * 0.2}s`} repeatCount="indefinite" />
                  <animate attributeName="opacity" values="1;0.3;1" dur="2.4s" begin={`${i * 0.2}s`} repeatCount="indefinite" />
                </circle>
              </g>
            );
          })}
          {hp && (
            <g>
              <circle cx={hp.x} cy={hp.y} r="5" fill="#00f0ff" stroke="#fff" strokeWidth="1" style={{ filter: "drop-shadow(0 0 8px #00f0ff)" }} />
            </g>
          )}
        </svg>
        <div className="absolute left-4 top-4 flex items-center gap-2 rounded-full bg-black/50 px-3 py-1.5 backdrop-blur">
          <span className="h-2 w-2 animate-pulse rounded-full bg-[#ff2d6f]" />
          <span className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-white/80">
            Filtraciones · Evaluación
          </span>
        </div>
      </div>
    </div>
  );
};
